import { Box, useTheme, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { motion } from "framer-motion";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserAuth } from "../context/AuthContext";
import Header from "./Header";
import TokenContext from "../context/TokenContext";
import { miLegajo } from "../Redux/legajo";
import { actualizarOtraInfo } from "../Redux/formacion";

const OtraInformacion = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const token = useContext(TokenContext);
    const { empleado } = UserAuth();

    const legajoSelector = useSelector(store => store.legajo.legajo)
    const [otraInfo, setOtraInfo] = React.useState('')

    React.useEffect(() => {
        if (token, empleado) {
            dispatch(miLegajo(token, empleado.empleadoid))
        }
    }, [token, empleado]);

    React.useEffect(() => {
        if (legajoSelector.length > 0) {
            const item = legajoSelector[0].new_informacionadicional;
            setOtraInfo(item);
        }
    }, [legajoSelector])

     //submit
     const handleSubmit = () => {
        if (token !== '') {
            dispatch((dispatch) => {
                dispatch(actualizarOtraInfo(token, otraInfo, empleado.empleadoid))
                    .then(() => {
                        // Actualiza cuando se cumple la promesa
                        dispatch(miLegajo(token, empleado.empleadoid))
                    });
            });
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box m="1.5rem 2.5rem">
                <Header
                    title={"Información adicional"}
                />
                <Grid container spacing={2}>

                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <TextField
                            color="secondary"
                            label="Información adicional"
                            value={otraInfo || ''}
                            onChange={e => setOtraInfo(e.target.value)}
                            InputProps={{ style: { fontWeight: 'bold' } }}
                            fullWidth
                            multiline
                            rows={4}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button color="secondary" variant="contained" onClick={()=> handleSubmit()}>Actualizar</Button>
                    </Grid>
                </Grid>
            </Box>
        </motion.div>
    )
}

export default OtraInformacion